module.exports = __webpack_public_path__ + "img/20180414165936.d159905f.jpg";